'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hash = require('glamor/lib/hash');

var _hash2 = _interopRequireDefault(_hash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var babelPluginFlowReactPropTypes_proptype_NameGenerator = require('../types').babelPluginFlowReactPropTypes_proptype_NameGenerator || require('react').PropTypes.any;

var babelPluginFlowReactPropTypes_proptype_Interpolation = require('../types').babelPluginFlowReactPropTypes_proptype_Interpolation || require('react').PropTypes.any;

var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

exports.default = function (nameGenerator, GlobalStyle, css) {
  return function (strings) {
    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    var rules = css.apply(undefined, [strings].concat(interpolations));
    var hash = (0, _hash2.default)(replaceWhitespace(JSON.stringify(rules)));
    var name = nameGenerator(hash);
    var keyframes = new GlobalStyle(rules, name, '@keyframes');
    keyframes.generateAndInject();
    return name;
  };
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/styled-components/lib/constructors/keyframes.js
// module id = 1360
// module chunks = 0